<template>
  <div class="home">
    <div class="ui bottom attached container" ref="modules_segment">
      <div v-responsive.lg.xl>
        <div class="ui form">
          <div class="three wide column field" style="float: right">
            <label for>{{ $t("search module") }}</label>
            <div class="ui right floated icon input">
              <input type="text" :placeholder="$t('search')" v-model="filter" />
              <i class="search icon"></i>
            </div>
          </div>
        </div>
        <h2 class="ui center aligned icon header modul_header"></h2>
      </div>
      <div v-responsive.md>
        <div class="ui form">
          <div class="four wide column field" style="float: right">
            <label for>{{ $t("search module") }}</label>
            <div class="ui right floated icon input">
              <input type="text" :placeholder="$t('search')" v-model="filter" />
              <i class="search icon"></i>
            </div>
          </div>
        </div>
        <h2 class="ui center aligned icon header modul_header"></h2>
      </div>
      <div v-responsive.sm.xs class="ui container">
        <h2 class="ui center aligned icon header modul_header"></h2>
        <div class="ui form">
          <div class="field">
            <label for>{{ $t("search module") }}</label>
            <div class="ui right floated icon input">
              <input type="text" :placeholder="$t('search')" v-model="filter" />
              <i class="search icon"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <div v-responsive.lg.xl>
          <desktop
            :display_modules="display_modules"
            @go_to_module="go_to_module"
          />
        </div>
        <div v-responsive.md>
          <tablet
            :display_modules="display_modules"
            @go_to_module="go_to_module"
          />
        </div>
        <div v-responsive.sm.xs>
          <smartphone
            :display_modules="display_modules"
            @go_to_module="go_to_module"
          />
        </div>
        <!-- <div class="ui six link cards">
          <div
            class="card"
            v-for="module in display_modules"
            v-bind:key="module.module_id"
            v-on:click="go_to_module(module)"
            style="margin: 10px 10px !important"
          >
            <div class="content">
              <h3 class="ui icon header" style="margin-bottom:0">
                <img :src="module.sys_module.setup.image" class="ui image" />
                <div class="content" style="margin-top:8px">
                  {{ $t(module.sys_module.setup.name) }}
                </div>
              </h3>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, clone } from "../utils";
import Desktop from "./home/Desktop.vue";
import Tablet from "./home/Tablet.vue";
import Smartphone from "./home/Smartphone.vue";
// import "tinymce";
// import "tinymce/themes/silver/theme";

// @ is an alias to /src
export default {
  name: "Home",
  components: { Desktop, Tablet, Smartphone },
  data() {
    return {
      modules: [],
      display_modules: [],
      filter: "",
    };
  },
  methods: {
    go_to_module(suscription) {
      this.$router.push({
        name: suscription.sys_module.setup.index_route,
      });
    },
  },
  created() {},
  mounted() {
    let vm = this;

    window.jQuery(vm.$refs.modules_segment).addClass("loading");
    local_api(vm, "post", "/user/do-get-home-modules")
      .then((response) => {
        let display_modules = response.sort(function (a, b) {
          if (vm.$t(a.sys_module.setup.name) > vm.$t(b.sys_module.setup.name))
            return 1;
          if (vm.$t(a.sys_module.setup.name) < vm.$t(b.sys_module.setup.name))
            return -1;
          return 0;
        });
        vm.modules = display_modules;
        vm.display_modules = clone(display_modules);
        window.jQuery(vm.$refs.modules_segment).removeClass("loading");
      })
      .catch((err) => {
        window.jQuery(this.$refs.modules_segment).toast({
          message: err,
          class: "error",
          showImage: "/images/error.png",
          classImage: "avatar",
          title: "Error",
          showProgress: "bottom",
          classProgress: "blue",
        });
      });
  },
  watch: {
    filter() {
      let vm = this;
      if (vm.filter == "") vm.display_modules = clone(vm.modules);
      else
        vm.display_modules = vm.modules
          .filter((n) => {
            let name = vm.$t(n.sys_module.setup.name).toUpperCase();
            let description = n.sys_module.setup.description.toUpperCase();

            return (
              name.includes(vm.filter.toUpperCase()) ||
              description.includes(vm.filter.toUpperCase())
            );
          })
          .sort(function (a, b) {
            let aname = vm.$t(a.sys_module.setup.name).toUpperCase();
            let bname = vm.$t(b.sys_module.setup.name).toUpperCase();
            if (aname > bname) {
              return 1;
            }
            if (aname < bname) {
              return -1;
            }
            return 0;
          });
    },
  },
};
</script>

<style>
.modul_header {
  background-image: url(/images/backgrounds/Modul-15-1.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 75px;
}

.card .ui.header .content {
  font-size: 1.25rem !important;
}
</style>
